export const ACTION = {
  CONTACT_ATTEMPTED: 'CONTACT_ATTEMPTED',
  DISMISSED: 'DISMISSED',
  RESOLVED: 'RESOLVED',
};
export const ACTIONS = Object.values(ACTION);
